import { getCurrencyMinorUnitExponent } from './getCurrencyMinorUnitExponent';

export function amountFromBaseUnits(amount: number, currency: string): number {
	return amount / 10 ** getCurrencyMinorUnitExponent(currency);
}
